export default __webpack_public_path__ + "static/media/safari.958337f6.png";